import {influenceClasses} from '../alpine-functions'


export default () => ({


    influenceClasses(politician) {
        return influenceClasses(politician);
    },

})
